module.exports = __webpack_public_path__ + "img/qr.d55903eb.svg";